export default __webpack_public_path__ + "static/18-a172324afc6312a7437a45ea86ecb23e.jpg";